import React from "react";
import { Form, Row, Col, Input, Select, Button, message, Icon } from "antd";
import img from "./../../../assets/img/freepik  Plant  inject 2.png";
import MiCompAPI from "./../../../util/api";
import FileBase64 from "react-file-base64";

const { Option } = Select;

class Compliance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isValueExists: false,
      docs: [
        "Agency Contract",
        "W9 form",
        "AHIP_Medicare_Certification",
        "Broker E&O Page",
        "ACH Form",
        "Broker License",
        "Broker Contract",
        "Others",
      ],
      title: this.props.doc_type
        ? "Update Compliance"
        : "New Compliance Requirement",
      upload_doc: this.props.doc_type ? false : true,
    };

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err && !this.state.isValueExists) {
        if (this.fileData) {
          if (this.fileData.file.size > 15728640) {
            message.warning("File size must under 15MiB!", 3);
          } else if (this.fileData.name.split(".")[1] !== "pdf") {
            message.error("Invalid file format!, Plese upload PDF file.", 10);
          } else {
            let data = {
              ...values,
              id: this.props.doc_type ? this.props.doc_type.id : 0,
              document_Name:
                values.document_Name !== "Others"
                  ? values.document_Name
                  : values.other_document_Name,
              unq_FileName: this.fileData.base64,
              fileName: this.fileData.name,
            };

            this.props.submitHandler(data, (val) => {
              if (!val) {
              }
            });
          }
        } else if (this.props.doc_type) {
          let data = {
            ...values,
            id: this.props.doc_type ? this.props.doc_type.id : 0,
            document_Name:
              values.document_Name !== "Others"
                ? values.document_Name
                : values.other_document_Name,
          };

          this.props.submitHandler(data, (val) => {
            if (!val) {
            }
          });
        } else {
          message.error("Plese upload PDF file.", 10);
        }
      } else {
      }
    });
  };
  componentDidMount = () => {
    const { setFieldsValue } = this.props.form;
    const { doc_type } = this.props;
    if (doc_type) {
      setTimeout(() => {
        const otherdoc =
          this.state.docs.filter((x) => x === doc_type.document_Name).length >
          0;
        setFieldsValue({
          document_Name: otherdoc ? doc_type.document_Name : "Others",
          other_document_Name: !otherdoc && doc_type.document_Name,
          isRequired: doc_type.isRequired,
          applicable_To: doc_type.applicable_To,
          approverSignatureIsRequired: doc_type.approverSignatureIsRequired,
        });
      }, 100);
    }
  };
  handleAddDocument = (data) => {
    if (data.file.size > 15728640) {
      message.warning("File size must under 15MiB!", 3);
    }
    if (data.name.split(".")[1] !== "pdf") {
      message.error("Invalid file format!, Plese upload PDF file.", 10);
    }

    this.fileData = data;
  };
  handleChange = (e) => {
    if (e.target.value && e.target.value.length > 4) {
      this.api.invoke(
        "IsValueExists/DocumentType/" + e.target.value + "/DOCNAME",
        "get",
        (data, success) => {
          if (success) {
            this.setState({ isValueExists: data.data });
          }
        }
      );
    }
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    const { doc_type } = this.props;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className="mi_title" style={{ marginLeft: "8px" }}>
              {this.state.title}
              <br></br>
              <span className="mi_title2">
                Fill up the following form in order to new a Compliance
              </span>
            </p>
          </Col>
          <Col span={6}>
            <i
              className="fa fa-times mi_icon mi_icon_red mi_button_close"
              onClick={this.props.closeDrawerHandler}
            ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={24} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Document Name</legend>

                  {getFieldDecorator("document_Name", {
                    rules: [
                      {
                        required: true,
                        message: (
                          <span style={{ marginTop: "-6px !important" }}>
                            {" "}
                            Please select a Document Name.{" "}
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Select
                      onChange={(e) => this.handleChange.bind(e)}
                      suffixIcon={
                        <Icon
                          style={{ transform: "rotate(90deg)" }}
                          type="double-right"
                        />
                      }
                      className="mi_input"
                      placeholder="Please Select *"
                    >
                      {this.state.docs.map((x) => {
                        return (
                          <Option value={x} key={x}>
                            {x}
                          </Option>
                        );
                      })}
                    </Select>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            {((doc_type &&
              this.state.docs.filter((x) => x === doc_type.document_Name)
                .length === 0) ||
              getFieldValue("document_Name") === "Others") && (
              <Col md={24} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Document Name</legend>

                    {getFieldDecorator("other_document_Name", {
                      rules: [
                        {
                          required: true,
                          message: "Please Enter Other Document Name",
                        },
                      ],
                    })(
                      <Input
                        className="mi_input"
                        onChange={this.handleChange.bind(this)}
                        maxLength={40}
                        type="text"
                        placeholder="Please enter Document Name*"
                      />
                    )}
                  </fieldset>
                </Form.Item>
                {this.state.isValueExists ? (
                  <p
                    style={{
                      color: "red",
                      marginTop: "-12px",
                      marginLeft: "10px",
                    }}
                  >
                    Document Name already exists
                  </p>
                ) : (
                  ""
                )}
              </Col>
            )}
            <Col md={24} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Mandatory</legend>

                  {getFieldDecorator("isRequired", {
                    rules: [
                      {
                        required: true,
                        message: (
                          <span style={{ marginTop: "-6px !important" }}>
                            {" "}
                            Please select a Document Required.{" "}
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Select
                      suffixIcon={
                        <Icon
                          style={{ transform: "rotate(90deg)" }}
                          type="double-right"
                        />
                      }
                      className="mi_input"
                      placeholder="Please Select *"
                    >
                      <Option value={true} key={true}>
                        Yes
                      </Option>
                      <Option value={false} key={true}>
                        No
                      </Option>
                    </Select>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={24} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">
                    Approver Signature Required
                  </legend>

                  {getFieldDecorator("approverSignatureIsRequired", {
                    rules: [
                      {
                        required: true,
                        message: (
                          <span style={{ marginTop: "-6px !important" }}>
                            {" "}
                            Please select a Approver Signature Required.{" "}
                          </span>
                        ),
                      },
                    ],
                  })(
                    <Select
                      suffixIcon={
                        <Icon
                          style={{ transform: "rotate(90deg)" }}
                          type="double-right"
                        />
                      }
                      className="mi_input"
                      placeholder="Is Approver Signature Required*"
                    >
                      <Option value={true} key={true}>
                        Yes
                      </Option>
                      <Option value={false} key={true}>
                        No
                      </Option>
                    </Select>
                  )}
                </fieldset>
              </Form.Item>
            </Col>
            {role === "carrier" ? (
              <Col md={24} sm={24}>
                <Form.Item>
                  <fieldset className="mi_input_pop">
                    <legend className="legend-font">Role</legend>

                    {getFieldDecorator("applicable_To", {
                      rules: [
                        { required: true, message: "Please select Role" },
                      ],
                    })(
                      <Select
                        suffixIcon={
                          <Icon
                            style={{ transform: "rotate(90deg)" }}
                            type="double-right"
                          />
                        }
                        className="mi_input"
                        placeholder="Please Select a Role *"
                        showSearch={true}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={this.onChange}
                      >
                        {this.props.roles
                          ? this.props.roles.map((tag) => (
                              <Option value={tag.code} key={tag.code}>
                                {tag.name}
                              </Option>
                            ))
                          : null}
                      </Select>
                    )}
                  </fieldset>
                </Form.Item>
              </Col>
            ) : (
              ""
            )}
            <Col md={24} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Document File</legend>

                  <FileBase64 onDone={this.handleAddDocument} />
                  {this.props.doc_type ? (
                    <p
                      style={{
                        float: "right",
                        fontWeight: "bold",
                        margin: "6px -13px",
                      }}
                    >
                      {" "}
                      {this.props.doc_type.document_Name} File{" "}
                      <i
                        style={{
                          marginRight: "0px !important",
                          marginTop: "10px",
                        }}
                        onClick={() =>
                          window.open(
                            this.props.doc_type.unq_FileName,
                            "_blank"
                          )
                        }
                        className="fa fa-eye fa-b"
                      />
                    </p>
                  ) : (
                    ""
                  )}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>

          <Row span={24} style={{ marginTop: "30px" }}>
            <Col span={7}></Col>
            <Col span={5}>
              <Button
                className="mi_button_right submit-button"
                onClick={this.props.closeDrawerHandler}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
            </Col>
            <Col span={5}>
              <Button
                htmlType="submit"
                className="submit-button"
                type="primary"
              >
                Submit
              </Button>
            </Col>
            <Col span={7}>
              <img
                alt="example"
                style={{
                  height: "70px",
                  marginBottom: "-30px",
                  float: "right",
                }}
                src={img}
              />
            </Col>
            <Col span={7}></Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const AddManageCompliance = Form.create()(Compliance);
export default AddManageCompliance;
